import firebase from "@/firebase";

export default {
  namespaced: true,
  state: [],
  mutations: {
    setFields(state, newValue) {
      state.splice(0, state.length, ...newValue);
    },
    addField(state, newEntry) {
      state.push(newEntry);
    },
    updateField(state, payload) {
      const index = state.findIndex((x) => x.id === payload.id);
      if (index >= 0) {
        state.splice(index, 1, { ...state[index], ...payload });
      }
    },
  },
  actions: {
    async initFields(state) {
      if (!firebase.auth.currentUser) return;

      const fieldsResult = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("fields")
        .get();

      const output = [];
      fieldsResult.forEach((entry) => {
        const info = { ...entry.data(), id: entry.id };
        info.type = info.type || "number";
        if (info.type === "number") {
          info.range = info.range || { low: null, high: null };
          info.goal = info.goal || null;
        }

        output.push(info);
      });

      state.commit("setFields", output);
    },
  },
};
